// Cookie Policy Page
import { useEffect } from "react";
import Navigation from "../components/shared/Navigation";
import Footer from "../components/shared/Footer";
import { usePageMeta } from "../components/shared/SEOHelper";

const CookiePolicyPage = () => {
  usePageMeta({
    title: "Cookie Policy | Annelie Lily Yoga | Frome, Somerset",
    description: "Cookie policy for Annelie Lily Yoga website. Learn about the cookies we use, how to manage them, and third-party cookies from Google Analytics.",
    canonical: "https://annelielily.com/cookie-policy"
  });

  return (
    <div className="min-h-screen bg-cream">
      <Navigation />
      
      <main className="pt-28 pb-16 px-6 md:px-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-4xl text-neutral-800 mb-8">
            Cookie Policy
          </h1>
          
          <div className="prose prose-neutral max-w-none space-y-6 text-neutral-700">
            <p>
              This is the Cookie Policy for Annelie Lily Yoga (Seventh Sense Healing), accessible from annelielily.com
            </p>

            <section>
              <h2 className="font-heading text-xl text-neutral-800 mt-8 mb-4">What Are Cookies</h2>
              <p>
                As is common practice with almost all professional websites, this site uses cookies, which are tiny files 
                that are downloaded to your computer, to improve your experience. This page describes what information they 
                gather, how we use it and why we sometimes need to store these cookies. We will also share how you can 
                prevent these cookies from being stored however this may downgrade or 'break' certain elements of the site's 
                functionality.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-neutral-800 mt-8 mb-4">How We Use Cookies</h2>
              <p>
                We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry 
                standard options for disabling cookies without completely disabling the functionality and features they add 
                to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or 
                not in case they are used to provide a service that you use.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-neutral-800 mt-8 mb-4">Disabling Cookies</h2>
              <p>
                You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for 
                how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites 
                that you visit. Disabling cookies will usually result in also disabling certain functionality and features of 
                this site. Therefore it is recommended that you do not disable cookies.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-neutral-800 mt-8 mb-4">The Cookies We Set</h2>
              <ul className="list-disc pl-6 space-y-4">
                <li>
                  <strong>Account related cookies:</strong> If you create an account with us then we will use cookies for 
                  the management of the signup process and general administration. These cookies will usually be deleted 
                  when you log out however in some cases they may remain afterwards to remember your site preferences when 
                  logged out.
                </li>
                <li>
                  <strong>Login related cookies:</strong> We use cookies when you are logged in so that we can remember this 
                  fact. This prevents you from having to log in every single time you visit a new page. These cookies are 
                  typically removed or cleared when you log out to ensure that you can only access restricted features and 
                  areas when logged in.
                </li>
                <li>
                  <strong>Forms related cookies:</strong> When you submit data through a form such as those found on contact 
                  pages or comment forms, cookies may be set to remember your user details for future correspondence.
                </li>
                <li>
                  <strong>Site preferences cookies:</strong> In order to provide you with a great experience on this site we 
                  provide the functionality to set your preferences for how this site runs when you use it. In order to remember 
                  your preferences we need to set cookies so that this information can be called whenever you interact with a 
                  page is affected by your preferences.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl text-neutral-800 mt-8 mb-4">Third Party Cookies</h2>
              <p>
                In some special cases we also use cookies provided by trusted third parties. The following section details 
                which third party cookies you might encounter through this site.
              </p>
              <ul className="list-disc pl-6 space-y-4 mt-4">
                <li>
                  <strong>Google Analytics:</strong> This site uses Google Analytics which is one of the most widespread and 
                  trusted analytics solutions on the web for helping us to understand how you use the site and ways that we 
                  can improve your experience. These cookies may track things such as how long you spend on the site and the 
                  pages that you visit so we can continue to produce engaging content.
                </li>
                <li>
                  <strong>Social media:</strong> We also use social media buttons and/or plugins on this site that allow you 
                  to connect with your social network in various ways. For these to work, social media sites including Facebook, 
                  Instagram and YouTube, will set cookies through our site which may be used to enhance your profile on their 
                  site or contribute to the data they hold for various purposes outlined in their respective privacy policies.
                </li>
                <li>
                  <strong>Booking system:</strong> Our online booking system may set its own 
                  cookies to manage your booking experience and remember your preferences.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl text-neutral-800 mt-8 mb-4">Managing Your Cookie Preferences</h2>
              <p>
                When you first visit our website, you will be shown a cookie consent banner that allows you to accept or 
                decline non-essential cookies. You can change your preferences at any time by clearing your browser cookies 
                and revisiting the site.
              </p>
              <p className="mt-4">
                Most web browsers allow some control of most cookies through the browser settings. To find out more about 
                cookies, including how to see what cookies have been set, visit{" "}
                <a href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">
                  www.aboutcookies.org
                </a>.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-neutral-800 mt-8 mb-4">More Information</h2>
              <p>
                Hopefully that has clarified things for you. If there is something that you aren't sure whether you need or 
                not it's usually safer to leave cookies enabled in case it does interact with one of the features you use on 
                our site.
              </p>
              <p className="mt-4">
                However if you are still looking for more information then you can contact us through one of our preferred 
                contact methods:
              </p>
              <ul className="list-disc pl-6 mt-4">
                <li>Email: <a href="mailto:seventhsensehealing@outlook.com" className="text-gold hover:underline">seventhsensehealing@outlook.com</a></li>
                <li>Phone: <a href="tel:07540995021" className="text-gold hover:underline">07540 995021</a></li>
              </ul>
            </section>

            <div className="mt-12 pt-8 border-t border-gold/20">
              <p className="text-sm text-neutral-500">
                Last updated: December 2025
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CookiePolicyPage;
